import httpAuth from '../../services/httpAuth'
import httpNotAuth from '../../services/httpNotAuth'
import getErrorMessage from '../../helpers/getErrorMessage.helper'
import { getCompetitionSuccess, getCompetitionError } from './competitions.slice'

export const requestCompetition = (series_id) => async (dispatch, getState) => {
  const checkAuth = getState().auth
  
  if(checkAuth) {
    try {
      dispatch(getCompetitionSuccess(null))
      const response = await httpAuth.post(`match/homeMatches`, {series_id})
      if (response.data.status) {
        dispatch(getCompetitionSuccess(response.data.data))
      }
      return response
    } catch (e) {
      dispatch(getCompetitionError())
      // const errorMsg = getErrorMessage(e)
      // throw errorMsg
    }
  } else {
    try {
      dispatch(getCompetitionSuccess(null))
      const response = await httpNotAuth.post(`match/homeMatchesOpen`, {series_id})
      if (response.data.status) {
        dispatch(getCompetitionSuccess(response.data.data))
      }
      return response
    } catch (e) {
      dispatch(getCompetitionError())
      // const errorMsg = getErrorMessage(e)
      // throw errorMsg
    }
  }
}